import React from 'react';
import { Grid } from 'semantic-ui-react';

// Global Components
import FieldValue from 'components/FieldValue';

// Form
// @ts-ignore
import validators, { isRequired } from 'forms/validators';
import SprayedEntitiesByDateRequest from 'scenes/Spray/scenes/Diary/components/SprayedEntitiesByDateRequest';
import {
    SprayEventStartDate,
    SprayEntityIds
} from 'services/sprayEvents/types';

// Child Components
// @ts-ignore
import { SPRAYED_ENTITIES_BY_DATE_LOAD_NAMESPACE } from 'services/sprayedEntitiesByDate/constants';
import { Field } from 'react-final-form';
import { RenderDatePicker } from 'forms';
import SpraySchemaEntityTypeEntityDropdownField from '../SpraySchemaEntityTypeEntityDropdownField';
import SpraySchemaInnerEntityTableField from '../SpraySchemaInnerEntityTableField';
import TotalAreaField from './components/TotalAreaField';

interface Props {
    isEditing?: boolean;
}

export default function SchedulePage(props: Props): React.ReactElement {
    const { isEditing = false } = props;

    return (
        <Grid className="spray-event-modal-step">
            <FieldValue name="startDate">
                {(value: SprayEventStartDate): React.ReactElement => (
                    <SprayedEntitiesByDateRequest
                        startDate={value}
                        namespace={SPRAYED_ENTITIES_BY_DATE_LOAD_NAMESPACE}
                    />
                )}
            </FieldValue>
            <Grid.Row>
                <Grid.Column width="8">
                    <h4>Schedule details</h4>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width="8">
                    <Field
                        name="startDate"
                        subscription={{
                            value: true,
                            touched: true,
                            error: true
                        }}
                        validate={isRequired}
                        component={RenderDatePicker as any}
                        label="Spray date"
                        placeholder="Add spray date"
                        dateFormat="EEE do MMM"
                        selectsStart
                    />
                </Grid.Column>
                <Grid.Column width="8">
                    <FieldValue name="startDate">
                        {(
                            startDate: SprayEventStartDate
                        ): React.ReactElement => (
                            <SpraySchemaEntityTypeEntityDropdownField
                                name="entityId"
                                validate={validators.isRequired}
                                disabled={isEditing || !startDate}
                            />
                        )}
                    </FieldValue>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width="16">
                    <FieldValue name="sprayEntityIds">
                        {(value: SprayEntityIds): React.ReactElement => (
                            <TotalAreaField entityIds={value} />
                        )}
                    </FieldValue>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width="16">
                    <FieldValue name="entityId">
                        <SpraySchemaInnerEntityTableField
                            name="sprayEntityIds"
                            validate={validators.hasLength}
                        />
                    </FieldValue>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}
